import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Fragment } from 'react';
import { Button } from '../../elements/trustyle-button';
import { TruArrow, TruCheckmark } from '@uswitch/spark-icons/tru';
import ProgressCircle from '../../elements/progress-circle';
import FormStepField from './form-step-field';
import { isEmpty } from '@uswitch/ev-utils/obj';
import { useComponentTracking } from '@uswitch/ev-utils/component-events';
import trackFields from '../../../utils/form-track-fields';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var getFields = function getFields() {
  var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return step.fields;
};

var getFieldNames = function getFieldNames() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return fields.map(function (_ref) {
    var name = _ref.name,
        children = _ref.children;
    return children ? getFieldNames(children) : name;
  }).reduce(function (arr, nameOrNames) {
    return arr.concat(nameOrNames);
  }, []);
};

var FormStepFields = function FormStepFields(_ref2) {
  var fields = _ref2.fields,
      register = _ref2.register,
      errors = _ref2.errors,
      setValue = _ref2.setValue,
      triggerValidation = _ref2.triggerValidation,
      formType = _ref2.formType,
      variant = _ref2.variant,
      getValues = _ref2.getValues,
      goToPage = _ref2.goToPage,
      updateCompletionState = _ref2.updateCompletionState,
      onKeyDownFunction = _ref2.onKeyDownFunction,
      addressLookup = _ref2.addressLookup,
      privacyPolicyLink = _ref2.privacyPolicyLink,
      _ref2$trackInteractio = _ref2.trackInteraction,
      trackInteraction = _ref2$trackInteractio === void 0 ? function () {} : _ref2$trackInteractio,
      sectionTitle = _ref2.sectionTitle;
  return fields.map(function (field, i) {
    return _jsx(FormStepField, {
      field: field,
      register: register,
      errors: errors,
      setValue: setValue,
      triggerValidation: triggerValidation,
      formType: formType,
      variant: variant,
      getValues: getValues,
      goToPage: goToPage,
      updateCompletionState: updateCompletionState,
      onKeyDownFunction: onKeyDownFunction,
      trackInteraction: trackInteraction,
      sectionTitle: sectionTitle,
      index: i,
      addressLookup: addressLookup,
      privacyPolicyLink: privacyPolicyLink
    }, "field-".concat(i));
  }, this);
};

var FormStep = function FormStep(_ref3) {
  var step = _ref3.step,
      formType = _ref3.formType,
      register = _ref3.register,
      disableButtonUntilValid = _ref3.disableButtonUntilValid,
      errors = _ref3.errors,
      setValue = _ref3.setValue,
      triggerValidation = _ref3.triggerValidation,
      activeIndex = _ref3.activeIndex,
      stepIndex = _ref3.stepIndex,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'default' : _ref3$variant,
      goBack = _ref3.goBack,
      _goForward = _ref3.goForward,
      goToFirst = _ref3.goToFirst,
      goToLast = _ref3.goToLast,
      totalSteps = _ref3.totalSteps,
      goToPage = _ref3.goToPage,
      goToUrl = _ref3.goToUrl,
      watch = _ref3.watch,
      isErrored = _ref3.isErrored,
      isLoading = _ref3.isLoading,
      isValid = _ref3.isValid,
      updateCompletionState = _ref3.updateCompletionState,
      getValues = _ref3.getValues,
      _editFromSummary = _ref3.editFromSummary,
      withBackButton = _ref3.withBackButton,
      _ref3$trackInteractio = _ref3.trackInteraction,
      trackInteraction = _ref3$trackInteractio === void 0 ? function () {} : _ref3$trackInteractio,
      query = _ref3.query,
      handleSubmit = _ref3.handleSubmit,
      onSubmit = _ref3.onSubmit,
      addressLookup = _ref3.addressLookup,
      _ref3$meta = _ref3.meta,
      meta = _ref3$meta === void 0 ? {} : _ref3$meta;

  var isVisible = function isVisible(field) {
    if (!field.visibleIf) return true;
    return (field.visibleIf.or || []).some(function (e) {
      return watch(e.field) === e.equals;
    }) && (field.visibleIf.and || []).every(function (e) {
      return watch(e.field) === e.equals;
    });
  };

  var getStatePath = function getStatePath() {
    var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'panel';
    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'base';
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var submitSection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return "elements.form-section.".concat(variant, ".").concat(state === 'base' ? 'elements' : "states.".concat(state), ".").concat(path).concat(submitSection ? '.submit' : '');
  };

  var getVisibleFields = function getVisibleFields() {
    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return fields.filter(function (field) {
      return isVisible(field);
    });
  };

  var formError = step.formError;
  var privacyPolicyLink = meta.privacyPolicyLink;
  var isActive = activeIndex === stepIndex;
  var title = step.sectionName;
  var description = step === null || step === void 0 ? void 0 : step.sectionDescription;
  var fields = getVisibleFields(getFields(step));
  var isComplete = activeIndex > stepIndex;
  var state = isActive ? 'isActive' : isComplete ? 'isComplete' : 'base';

  var variantPath = function variantPath(path, submitSection) {
    return getStatePath(variant, state, path, submitSection);
  };

  var buttonProps = Array.isArray(step.buttonProps) ? getVisibleFields(step.buttonProps) : getVisibleFields([step.buttonProps]);
  var submitSection = title === 'Submit';
  var formFieldVariantToTheme = {
    default: 'default',
    simple: 'simple',
    panel: 'field-section',
    journey: 'journey',
    onboarding: 'onboarding',
    'mortgages-broker': 'mortgages-broker',
    slide: 'slide',
    'platinum-ppc': 'platinum-ppc'
  };
  var trackComponent = useComponentTracking();
  var id = step.id;

  var validateButtonFunction = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(func) {
      var passedValidation, gtmTrackingFields, fieldValuesToTrack;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return triggerValidation(getFieldNames(fields));

            case 2:
              passedValidation = _context.sent;

              if (!passedValidation) {
                _context.next = 10;
                break;
              }

              if (!query.formCompleted) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", handleSubmit(onSubmit));

            case 6:
              trackComponent('Form Event', 'stepSubmitted', fields.reduce(function (o, f) {
                return _objectSpread(_defineProperty({}, f.name, f.trackInput ? getValues(f.name) : 'untracked'), o);
              }, {
                sectionName: step.sectionName,
                sectionIndex: stepIndex
              }));
              gtmTrackingFields = trackFields(fields);

              if (gtmTrackingFields.length) {
                fieldValuesToTrack = gtmTrackingFields.map(function (fieldToTrack) {
                  return fieldToTrack && {
                    fieldName: fieldToTrack,
                    values: getValues(fieldToTrack)
                  };
                });
                fieldValuesToTrack.forEach(function (_ref5) {
                  var fieldName = _ref5.fieldName,
                      values = _ref5.values;
                  trackInteraction('GA Form Step Submitted', 'Form Interaction', "".concat(fieldName, ":").concat(values));
                });
              }

              return _context.abrupt("return", func());

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function validateButtonFunction(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var selectButtonFunction = function selectButtonFunction(action, url) {
    var btnFuncs = {
      goForward: function goForward() {
        return validateButtonFunction(_goForward);
      },
      goBack: goBack,
      goToFirst: goToFirst,
      goToLast: goToLast,
      editFromSummary: function editFromSummary() {
        return validateButtonFunction(_editFromSummary);
      },
      redirect: function redirect() {
        return goToUrl(url);
      }
    };
    return btnFuncs[action];
  };

  var onKeyDownFunction = buttonProps.map(function (_ref6) {
    var action = _ref6.action,
        url = _ref6.url;
    if (action === 'editFromSummary' || action === 'goForward' || action === 'redirect') return selectButtonFunction(action, url);
  });
  return _jsxs(Fragment, {
    children: [_jsxs("div", {
      id: id,
      sx: {
        variant: variantPath(formType === 'calculator' ? 'wrapper.calculator' : 'wrapper', submitSection)
      },
      children: [withBackButton && activeIndex !== 0 ? _jsx("div", {
        role: "button",
        sx: {
          ml: ['sm', 'xxl', 'xxxl'],
          mb: 'sm',
          cursor: 'pointer',
          mt: 'sm'
        },
        onClick: function onClick() {
          return goBack();
        },
        children: _jsx(TruArrow, {
          color: 'black',
          sx: {
            transform: 'rotate(0.75turn)'
          },
          size: 20
        })
      }) : null, _jsxs("div", {
        sx: {
          variant: variantPath('heading', submitSection)
        },
        children: [!submitSection && title ? _jsx("h2", {
          variant: 'primary',
          sx: {
            mr: ['md', 'xl', 'xl'],
            variant: variantPath('heading.sectionName', submitSection)
          },
          children: title
        }) : null, !submitSection && description ? _jsx("h3", {
          variant: 'primary',
          sx: {
            mr: ['md', 'xl', 'xl'],
            variant: variantPath('heading.sectionDescription', submitSection)
          },
          children: description
        }) : null, isComplete ? _jsxs("div", {
          sx: {
            display: 'flex',
            alignItems: 'center'
          },
          children: [_jsx("div", {
            role: "button",
            sx: {
              mr: 'md',
              cursor: 'pointer',
              color: 'grey-60'
            },
            onKeyDown: function onKeyDown() {
              return goToPage(stepIndex);
            },
            onClick: function onClick() {
              goToPage(stepIndex);
            },
            tabIndex: "0",
            children: "Edit"
          }), _jsx(TruCheckmark, {
            color: "#64CD8D",
            size: 32
          })]
        }) : null]
      }), _jsx("div", {
        sx: {
          variant: formType === 'calculator' ? variantPath('fields.calculator') : variantPath('fields', submitSection)
        },
        children: _jsx(FormStepFields, {
          fields: fields,
          register: register,
          triggerValidation: triggerValidation,
          errors: errors,
          setValue: setValue,
          formType: formType,
          variant: formFieldVariantToTheme[variant],
          getValues: getValues,
          goToPage: goToPage,
          updateCompletionState: updateCompletionState,
          onKeyDownFunction: onKeyDownFunction,
          trackInteraction: trackInteraction,
          sectionTitle: title,
          addressLookup: addressLookup,
          privacyPolicyLink: privacyPolicyLink
        })
      }), step.buttonProps ? buttonProps.map(function (_ref7, index) {
        var label = _ref7.label,
            variant = _ref7.variant,
            action = _ref7.action,
            withIcon = _ref7.withIcon,
            url = _ref7.url;
        var shouldSubmit = stepIndex === totalSteps - 1 || query.formCompleted;
        var onClick = selectButtonFunction(action, url);
        return _jsx("div", {
          sx: {
            variant: formType === 'calculator' ? variantPath('buttonWrapper.calculator') : variantPath('buttonWrapper', submitSection)
          },
          children: _jsxs(Button, {
            type: shouldSubmit ? 'submit' : 'button',
            disabled: disableButtonUntilValid && !isValid || !isActive || !isEmpty(Object.keys(errors).filter(function (e) {
              return fields.map(function (f) {
                return f.name;
              }).includes(e);
            })) || isLoading,
            onClick: onClick,
            sx: {
              display: 'inline-flex',
              variant: isLoading ? 'elements.form.button.variants.loading' : formType === 'calculator' ? 'elements.form.button.variants.calculator' : withIcon ? 'elements.form.button.variants.icon' : 'elements.form.button.base'
            },
            variant: variant,
            size: step.buttonProps.size || 'large',
            children: [query.formCompleted ? 'Update results' : label, isLoading ? _jsx(ProgressCircle, {
              sx: {
                maxHeight: '32px'
              }
            }) : null, withIcon ? _jsx(TruArrow, {
              sx: {
                transform: 'rotate(0.25turn)'
              },
              color: "white",
              size: 18
            }) : null]
          }, "".concat(label, "-").concat(index))
        }, index);
      }) : null, formError && isErrored ? _jsxs("div", {
        sx: {
          variant: "elements.form.variants.".concat(variant, ".input.formError")
        },
        children: [_jsx("p", {
          sx: {
            variant: "elements.form.variants.".concat(variant, ".input.formError.title")
          },
          children: formError.title
        }), _jsx("p", {
          children: formError.description
        })]
      }) : null]
    }), step.postSection ? _jsx("div", {
      sx: {
        marginLeft: ['auto', '-200px'],
        marginBottom: 'lg',
        width: ['auto', ' 960px']
      },
      children: step.postSection.map(function (e, i) {
        return isVisible(e) ? _jsx("p", {
          sx: {
            fontWeight: e.bold ? 'bold' : 'normal'
          },
          children: e.text
        }, i) : null;
      })
    }) : null]
  });
};

export default FormStep;
//# sourceMappingURL=form-step.js.map